import { ApolloClient, gql, InMemoryCache } from '@apollo/client';
import { SCORE_API } from '../../../Constants';

const client = new ApolloClient({
  uri: SCORE_API,
  cache: new InMemoryCache(),
});

const GET_LEADER_BOARD = gql`
    query GetLeaderBoard($rank: Int!, $category: Int!, $address: String) {
      leaderBoard(rank: $rank, category: $category, address: $address) {
        results {
          address
          total
          category
          rank
        }
        yourRank
        yourData {
          address
          total
          category
          rank
        }
      }
    }`;

export const getLeaderBoard = (pool=1, address = '') => {
  let variables = {
    rank: 2,
    category: 8
  }
  if(pool === 2) variables = {
    rank: 3,
    category: 8
  }
  if(pool === 3) variables = {
    rank: 4,
    category: 8
  }
  if(address === null) address = ''
  if(address) variables['address'] = address
  const promiseCall = new Promise((resolve, reject)=>{
    client.query({
      query: GET_LEADER_BOARD, variables
    }).then(({error, data})=>{
      if (error) {
        reject([])
      }
      resolve(data)
    }).catch(error=>{reject([])})
  })

  return Promise.all([promiseCall])
}

const GET_LUCKEY = gql`
    query GetUserLucky($address: String!){
      luckyByAddress(address: $address){
        address
        namePool
        nameRound
        nameReward
      }
  }`;

export const getUserLucky = (address)=>{
  return client.query({
    query: GET_LUCKEY, variables:{
      address: address
    }
  }).then(({error, data})=>{
    if (error) {
      throw new Error(error);
    }
    return data
  }).catch(error=>{})
}
